export const CONFERENCE_NOT_STARTED        = 'CONFERENCE_NOT_STARTED';
export const CONFERENCE_CANT_START         = 'CONFERENCE_CANT_START';
export const CONFERENCE_NEEDS_CONFIRMATION = 'CONFERENCE_NEEDS_CONFIRMATION';
export const CONFERENCE_IN_PROGRESS        = 'CONFERENCE_IN_SESSION';
export const CONFERENCE_COMPLETED          = 'CONFERENCE_COMPLETED';
